import { isArray, isString } from '@shared/utils/assertions';
import qs from 'query-string';
import type { ActiveFilters } from '../../Catalog.cache';
import { SORT_BY_CODE } from '../../Catalog.cache';
import { ProductCatalogAttributeSelectionType } from '@graphql/generated';

const PRODUCT_FILTER_QS_PARSE_OPTIONS: qs.ParseOptions = { arrayFormat: 'separator', arrayFormatSeparator: '|' };

const deriveCompositeCode = (groupCode: string, valueCode: string) => `${groupCode}:${valueCode}`;

export const deriveActiveFiltersFromUrl = (url: string): ActiveFilters => {
  const { query } = qs.parseUrl(url, PRODUCT_FILTER_QS_PARSE_OPTIONS);
  const productFiltersParam = query.pf;

  if (productFiltersParam && typeof productFiltersParam === 'string') {
    // `productFiltersParam` is an encoded array string -- must process it
    const productFilters = qs.parse(productFiltersParam, PRODUCT_FILTER_QS_PARSE_OPTIONS);

    const filtersList = Object.keys(productFilters).reduce((acc, groupCode) => {
      const attributeValue = productFilters[groupCode];
      switch (groupCode) {
        case ProductCatalogAttributeSelectionType.priceRange:
        case SORT_BY_CODE:
          /**
           * If it's priceRange, then replace the value
           */
          if (typeof attributeValue === 'string') {
            acc[groupCode] = attributeValue ? attributeValue : false;
          }
          return acc;

        default:
          /**
           * If it's not priceRange, then add the value to the array
           */
          if (isArray(attributeValue)) {
            attributeValue.forEach(valueCode => {
              acc[deriveCompositeCode(groupCode, valueCode)] = true;
            });
          } else if (isString(attributeValue)) {
            acc[deriveCompositeCode(groupCode, attributeValue)] = true;
          }
          return acc;
      }
    }, {} as ActiveFilters);
    return filtersList;
  }

  return {};
};
